// src/utils/auth.js
import axios from 'axios';

let cachedCsrfToken = null;
let isFetchingCsrf = false;

export const getCsrfToken = async () => {
  if (cachedCsrfToken) return cachedCsrfToken;
  if (isFetchingCsrf) {
    await new Promise(resolve => setTimeout(resolve, 100));
    return cachedCsrfToken || '';
  }

  isFetchingCsrf = true;
  try {
    const response = await axios.get(`${process.env.REACT_APP_API_URL}/api/get-csrf-token/`, {
      withCredentials: true,
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      credentials: 'include',
    });
    cachedCsrfToken = response.data.csrfToken;
    return cachedCsrfToken;
  } catch (err) {
    console.error('[Auth] CSRF Token fetch error:', err.response?.status, err.message);
    return '';
  } finally {
    isFetchingCsrf = false;
  }
};

export const fetchUser = async () => {
  try {
    const csrfToken = await getCsrfToken();
    if (!csrfToken) return null;

    const response = await axios.get(`${process.env.REACT_APP_API_URL}/api/profile/`, {
      withCredentials: true,
      headers: {
        'X-CSRFToken': csrfToken,
        'Content-Type': 'application/json',
        'Accept': 'application/json',
      },
      credentials: 'include',
    });
    return response.data;
  } catch (err) {
    return null;
  }
};
